import React from 'react';
import { SvgIcon } from '@mui/material';

function TemplatesIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 98 98">
      <path
        d="M88.93 0.219971H9.06998C4.18998 0.219971 0.22998 4.18997 0.22998 9.05997V88.93C0.22998 93.81 4.19998 97.77 9.06998 97.77H88.93C93.81 97.77 97.78 93.8 97.78 88.93V9.05997C97.78 4.17997 93.81 0.219971 88.93 0.219971ZM90.59 28.24V56.12H34.64V28.24H90.59ZM90.57 63.33V88.93C90.57 89.85 89.85 90.56 88.93 90.56H34.62V63.33H90.57ZM7.42998 28.24H27.43V90.57H9.06998C8.14998 90.57 7.43998 89.86 7.43998 88.94V28.24H7.42998ZM9.06998 7.43997H88.93C89.85 7.43997 90.57 8.14997 90.57 9.06997V21.07H7.43998V9.06997C7.43998 8.14997 8.15998 7.43997 9.06998 7.43997Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default TemplatesIcon;
